import { plotTimeline } from "@/mocks/lustCaution";

export default function Plot() {
  return (
    <section id="plot" className="w-full bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-5xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Story</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              完整剧情解析：一个未完成的刺杀
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              要理解删减为什么重要，得先看清完整的故事结构。影片沿着四个阶段推进，
              王佳芝从执行任务，到与任务本身彼此消耗，直到最后关头的一次偏离。
            </p>
          </div>

          <ol className="mt-12 relative">
            <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true"></div>
            {plotTimeline.map((node, index) => (
              <li key={node.phase} className="relative pl-12 md:pl-16 pb-10 last:pb-0">
                <span className="absolute left-0 top-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm md:text-base">
                  {index + 1}
                </span>
                <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
                  <span className="text-accent-700 font-label text-xs md:text-sm tracking-wide">{node.phase}</span>
                  <h3 className="mt-2 font-heading text-xl md:text-2xl font-semibold text-foreground-950 leading-snug">
                    {node.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{node.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-6 rounded-lg bg-secondary-100/70 border border-secondary-200 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-full bg-secondary-500 text-background-50">
              <i className="ri-lightbulb-line text-2xl" aria-hidden="true"></i>
            </span>
            <p className="text-secondary-900 text-sm md:text-base leading-relaxed">
              把这条主线记牢，再回看删减片段就会更清楚：被拿掉的往往不是情节本身，而是人物在情节之间那段「怎么变化过来的」过程。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}